// Estilos compartidos de la pestaña Logística 2 (formato nuevo).
// Un solo estilo por nivel de acción: primario relleno solo para la acción
// pendiente principal; el resto, enlaces verdes; "Deshacer" siempre igual.
import React from 'react';

const claseBoton = 'h-11 md:h-[34px] px-3 rounded-lg border text-sm md:text-[13px] font-bold whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed';
export const botonPrincipal = `${claseBoton} bg-duetto-primary border-duetto-primary text-white hover:bg-opacity-90`;
export const botonSecundario = `${claseBoton} bg-white border-[#CBD3CF] text-[#16221D] hover:bg-gray-50`;
export const enlace = 'text-sm font-semibold text-[#11704F] hover:text-[#0B5139] hover:underline disabled:opacity-50 disabled:cursor-not-allowed';
export const enlacePequeno = 'text-xs font-semibold text-[#11704F] hover:underline disabled:opacity-50 disabled:cursor-not-allowed';
export const claseInput = 'px-2 py-1.5 min-h-[44px] md:min-h-0 text-base md:text-sm text-right border border-[#CBD3CF] rounded-lg focus:outline-none focus:ring-2 focus:ring-duetto-primary tabular-nums';
export const claseSelect = 'px-2 py-1.5 min-h-[44px] md:min-h-0 text-base md:text-sm border border-[#CBD3CF] rounded-lg focus:outline-none focus:ring-2 focus:ring-duetto-primary bg-white disabled:opacity-60';
export const claseSubtitulo = 'text-xs font-bold tracking-wider uppercase text-[#5B6B64]';
export const claseTitulo = 'text-sm font-extrabold text-[#16221D]';

// Tarjeta blanca del formato nuevo (mismo diseño que las del resto de la ficha)
export const Tarjeta = ({ titulo, accion = null, testid, children, id }) => (
  <section id={id} className="bg-white border border-[#E1E6E3] rounded-xl p-4 sm:p-5 scroll-mt-4" data-testid={testid}>
    {(titulo || accion) && (
      <div className="flex items-center justify-between gap-3 mb-3">
        {titulo && <h2 className={claseSubtitulo}>{titulo}</h2>}
        {accion}
      </div>
    )}
    {children}
  </section>
);

// Bloque plegable: cabecera con el título y "Ver" / "Ocultar"
export const Plegable = ({ titulo, abierto, onCambiar, testid, children }) => (
  <div className="rounded-lg border border-[#E1E6E3]" data-testid={testid}>
    <button
      type="button"
      onClick={() => onCambiar(!abierto)}
      aria-expanded={abierto}
      className="w-full flex items-center justify-between gap-2 px-3.5 py-2.5 text-left"
      data-testid={testid ? `${testid}-toggle` : undefined}
    >
      <span className="text-sm font-semibold text-[#16221D]">{titulo}</span>
      <span className="text-xs font-semibold text-[#11704F]">{abierto ? 'Ocultar' : 'Ver'}</span>
    </button>
    {abierto && <div className="px-3.5 pb-3 flex flex-col gap-3">{children}</div>}
  </div>
);

// Estado de una línea: hecho o pendiente (con palabras, sin iconos)
export const Estado = ({ ok, texto }) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs md:text-[11px] font-bold whitespace-nowrap ${
      ok ? 'bg-[#E3F3EC] text-[#0F5E43]' : 'bg-[#FDF0DC] text-[#92400E]'}`}
  >
    {texto || (ok ? 'Listo' : 'Falta')}
  </span>
);
